import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/loading.svg';
const SpinSvg = () => React.createElement(IconSvg, null);
export default SpinSvg;
